import Chart from 'chart.js/auto';

const DeviceDistributionChart = {
  chart: null,

  mounted() {
    console.log('DeviceDistributionChart mounted');
    this.initChart();
  },

  updated() {
    console.log('DeviceDistributionChart updated');
    this.updateChart();
  },

  destroyed() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },

  initChart() {
    try {
      const ctx = this.el.getContext('2d');
      
      const activeTenantDevices = parseInt(this.el.dataset.activeTenantDevices) || 0;
      const inactiveTenantDevices = parseInt(this.el.dataset.inactiveTenantDevices) || 0;
      const totalDevices = activeTenantDevices + inactiveTenantDevices;

      if (totalDevices === 0) {
        console.log('No data for device distribution chart');
        return;
      }

      this.chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Devices from Active Tenants', 'Devices from Inactive Tenants'],
          datasets: [{
            data: [activeTenantDevices, inactiveTenantDevices],
            backgroundColor: [
              '#F97316', 
              '#E5E7EB',
            ],
            borderColor: [
              '#EA580C', 
              '#D1D5DB', 
            ],
            borderWidth: 2,
            hoverBackgroundColor: [
              '#EA580C', 
              '#D1D5DB', 
            ],
            hoverBorderWidth: 3
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                color: '#374151', 
                font: { 
                  size: 13,
                  weight: '500'
                },
                padding: 15,
                usePointStyle: true,
                pointStyle: 'circle'
              }
            },
            tooltip: {
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              titleColor: '#fff',
              bodyColor: '#fff',
              padding: 12,
              cornerRadius: 8,
              displayColors: true,
              callbacks: {
                label: function(context) {
                  const label = context.label || '';
                  const value = context.parsed;
                  const percentage = ((value / totalDevices) * 100).toFixed(1);
                  return `${label}: ${value.toLocaleString()} (${percentage}%)`;
                }
              }
            }
          },
          cutout: '60%',
        }
      });

      console.log('DeviceDistributionChart initialized successfully');
    } catch (error) {
      console.error('Error initializing DeviceDistributionChart:', error);
    }
  },

  updateChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    this.initChart();
  }
};

export default DeviceDistributionChart;